/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({
  providedIn: 'root'
})
export class CompanyLegalEntityCofaceResourceService extends AbstractResourceService<LegalEntityModel, LegalEntityModel, any, any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('companyLegalEntityCofaceUrl'),
      LegalEntityModel,
      LegalEntityModel
    );
  }

  findAllCofaceLegalEntity(countryIsoCode: string, vatCode: string): Observable<JsonApiResource<LegalEntityModel[], any>> {
    return this.httpClient?.get(`${this.url}/${countryIsoCode}/${vatCode}`).pipe(this.mapToListOfObjects());
  }

}

